module.exports = __webpack_public_path__ + "media/images/games/35gender/doctor-15b9eb5f2afb62f012384562fe31b55e.png";